
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"60","height":"60","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"30","cy":"30","r":"30","fill":"#000C1F","fill-opacity":".48"}}),_c('path',{attrs:{"d":"M43.04 28.293L25.042 17.295A2 2 0 0022 19.001V41a2 2 0 003.043 1.706l17.996-10.998a2.002 2.002 0 000-3.414z","fill":"#fff"}})])
          )
        }
      }
    